export default "__VITE_ASSET__tXjX4rAu__"